// import { createContext, useContext, useState } from "react";

// // use:  caustomer car listing context
// const CarListCnxt = createContext();

// const CustomerCarsProvider = ({ children }) => {
//   const [customerCarCnxt, setCustomerCarCnxt] = useState({
//     customerCarOriginalList: [],
//     customerCarShowList: [],
//     pageIndex: 1,
//     searchTxt: "",
//   });
//   return (
//     <CarListCnxt.Provider value={{ customerCarCnxt, setCustomerCarCnxt }}>
//       {children}
//     </CarListCnxt.Provider>
//   );
// };
// const useCustomerCarCnxt = () => useContext(CarListCnxt);

// export { CustomerCarsProvider, useCustomerCarCnxt };
import { createContext, useContext, useState } from "react";

// Clearer name
const CustomerCarListContext = createContext();

export const CustomerCarProvider = ({ children }) => {
  const [carState, setCarState] = useState({
    originalList: [],
    showList: [],
    pageIndex: 1,
    searchText: "",
    hasMore: true,
  });

  // new logic
  const [searchContxt, setSearchContxt] = useState({
    state: { Value: "1", Text: "Gujarat" },
    // state: null,
    city: null,
    compid: null,
    modelid: null,
    fuel: null,
    ModelYear: [2003, new Date().getFullYear()],
    Pricerange: [50000, 50000000],
    KMange: [0, 500000],
    vehicle: null,
    Gear: null,
    owner: null,
  });
  const [resultsContxt, setResultsContxt] = useState([]); // for storing the result of filterd result

  const [pageIndexContxt, setPageIndexContxt] = useState(1); // for Load More

  const [UserloggedContxt, setUserloggedContxt] = useState(
    localStorage.getItem("ca1rt6_t") ? true : false
  ); // for User Login or not.

  return (
    <CustomerCarListContext.Provider
      value={{
        carState,
        setCarState,
        searchContxt,
        setSearchContxt,
        resultsContxt,
        setResultsContxt,
        pageIndexContxt,
        setPageIndexContxt,
        UserloggedContxt,
        setUserloggedContxt,
      }}
    >
      {children}
    </CustomerCarListContext.Provider>
  );
};

export const useCustomerCarContext = () => {
  const context = useContext(CustomerCarListContext); // Ensure that the context is not undefined
  if (!context) {
    throw new Error("useSearch must be used within a SearchProvider");
  }

  return context;
};
